import SectionCard, {
  SectionCardGroup
} from "@/appComponents/Blocks/Composites/SectionCard/SectionCard";
import UpgradeCard from "@/appComponents/Blocks/Composites/UpgradePopover/UpgradeCard";
import { UpgradeInfoCard } from "@/appComponents/Blocks/Composites/UpgradePopover/UpgradeInfoCard";
import { enumFeaturesList } from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";
import { DynamicTextProps } from "@theorgchartdev/storybook/dist/components/Text/DynamicText";

const UpgradeAccessGroups = () => {
  const upgradeAccessGroupsDynamicText: DynamicTextProps = {
    template: appstr("access groups upgrade template"),
    formatConfig: { bold1: { type: "bold" } },
    replaceDict: { bold1: appstr("custom access groups") }
  };

  return (
    <SectionCardGroup>
      <SectionCard
        title={appstr("Access groups")}
        customCardStyle={{ background: "var(--bg-brand-secondary)" }}
      >
        <div className="ocn-upgrade-card-text">
          <UpgradeCard iconName={"user-group"} featureKey={enumFeaturesList.accessGroups}>
            <UpgradeInfoCard.Body dynamic={upgradeAccessGroupsDynamicText}>
              {appstr("access groups upgrade message")}
            </UpgradeInfoCard.Body>
          </UpgradeCard>
        </div>
      </SectionCard>
    </SectionCardGroup>
  );
};

export default UpgradeAccessGroups;
